import { useDropzone } from "react-dropzone";

export default function UseCustomDropzone(onDrop) {
  return useDropzone({
    onDrop,
    accept: "image/*,application/pdf",
  });
}
